const AdManagement = {
  推广渠道: "merchantPromotionChannelManage",
  推广渠道__推广商: "merchantPromotionChannelManagePromoter",
  推广渠道__推广商__查看: "merchantPromotionChannelManagePromoterQueryPerm",
  推广渠道__推广商__新增: "merchantPromotionChannelManagePromoterAddPerm",
  推广渠道__推广商__修改: "merchantPromotionChannelManagePromoterEditPerm",
  推广渠道__推广商__删除: "merchantPromotionChannelManagePromoterDeletePerm",

  推广渠道__推广渠道: "merchantPromotionChannelManageChannel",
  推广渠道__推广渠道__查看: "merchantPromotionChannelManageChannelQueryPerm",
  推广渠道__推广渠道__新增: "merchantPromotionChannelManageChannelAddPerm",
  推广渠道__推广渠道__修改: "merchantPromotionChannelManageChannelEditPerm",
  推广渠道__推广渠道__删除: "merchantPromotionChannelManageChannelDeletePerm",

  推广渠道__推广渠道报表: "merchantPromotionChannelManageChannelReport",
  推广渠道__推广渠道报表__查看: "merchantPromotionChannelManageChannelReportQueryPerm",
  推广渠道__推广渠道报表__导出: "merchantPromotionChannelManageChannelReportExportPerm",

  推广渠道__推广效果报表: "merchantPromotionChannelManageEffectReport",
  推广渠道__推广效果报表__查看: "merchantPromotionChannelManageEffectReportQueryPerm",

  推广渠道__安装引导: "merchantPromotionChannelManageInstallGuide",
  推广渠道__安装引导__查看: "merchantPromotionChannelManageInstallGuideQueryPerm",
  推广渠道__安装引导__修改: "merchantPromotionChannelManageInstallGuideEditPerm",

  推广渠道__仿谷歌页配置: "merchantPromotionChannelManageGoogleConfig",
  推广渠道__仿谷歌页配置__查看: "merchantPromotionChannelManageGoogleConfigQueryPerm",
  推广渠道__仿谷歌页配置__新增: "merchantPromotionChannelManageGoogleConfigAddPerm",
  推广渠道__仿谷歌页配置__修改: "merchantPromotionChannelManageGoogleConfigEditPerm",
  推广渠道__仿谷歌页配置__删除: "merchantPromotionChannelManageGoogleConfigDeletePerm",
}

export default AdManagement
      